import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { BodyM, HeadingS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/customPopUpWithLoaderStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IPopUpProps {
	isOpen: boolean;
	hideDialog: () => void;
	loading: boolean;
	isError: boolean;
	header: string[];
	body?: string | JSX.Element;
	noMargin?: boolean;
}
const CustomPopUpWithLoader = ({
	isOpen,
	hideDialog,
	loading,
	isError,
	header,
	body,
	noMargin = false,
}: IPopUpProps) => {
	const classes = useStyles();

	return (
		<CustomConfirmationDialog
			isOpen={isOpen}
			hideDialog={hideDialog}
			withoutIcon={loading}
			isError={isError}
			noMargin={noMargin}
			header={
				<ConditionalRender
					show={!loading}
					onTrue={() => (
						<>
							{(header || []).map((el, i) => (
								<BodyM key={i} disableMargin>
									{el}
								</BodyM>
							))}
						</>
					)}
				/>
			}
		>
			<div>
				<ConditionalRender
					show={loading}
					onTrue={() => (
						<div className={classes.confirmationDialogLoader}>
							<CustomCircularProgress
								loading
								text={translate('number.services.confirmation.loading')}
								transparent
							/>
						</div>
					)}
					onFalse={() => (
						<ConditionalRender
							show={!!body}
							onTrue={() => (
								<div className={classes.bodyWrapper}>
									<HeadingS disableMargin color={isError ? 'danger' : 'success'}>
										{body}
									</HeadingS>
								</div>
							)}
						/>
					)}
				/>
			</div>
		</CustomConfirmationDialog>
	);
};

export default CustomPopUpWithLoader;
